export default "__VITE_ASSET__DlHF0oo9__"